<div class="chart-annotation-popup">
  <button class="chart-annotation-popup-close" type="button" (click)="close()">×</button>

  @if (mode === 'single' && comment) {
    @if (!isEditing) {
      <div class="chart-annotation-popup-body">
        <span class="chart-annotation-popup-text">{{ comment.text }}</span>
        <span class="chart-annotation-popup-actions">
          <i class="fa fa-edit" (click)="startEdit()"></i>
          <i class="fa fa-trash" (click)="deleteComment()"></i>
        </span>
      </div>
    }
    @if (isEditing) {
      <div class="chart-annotation-popup-body">
        <textarea rows="2" class="form-control" [(ngModel)]="editText"></textarea>
        <div class="chart-annotation-popup-btns">
          <button class="btn btn-outline-primary1" type="button" (click)="saveEdit()">{{ 'Update' | translate }}</button>
          <button class="btn" type="button" (click)="cancelEdit()">{{ 'Cancel' | translate }}</button>
        </div>
      </div>
    }
  }

  @if (mode === 'list') {
    <div class="chart-annotation-popup-list">
      @for (item of comments; track trackByCommentId($index, item)) {
        <div class="chart-annotation-popup-list-item">
          <span class="chart-annotation-popup-text">{{ item.text }}</span>
          <i class="fa fa-comment-alt link-cursor" (click)="selectComment(item)"></i>
        </div>
      }
    </div>
  }
</div>
